<ng-container *transloco="let t; prefix: 'shared.updateAvailableDialog'">
  <h2 mat-dialog-title>{{ t('title') }}</h2>
  <mat-dialog-content>
    @if (allowDelay) {
      {{ t('delayText') }}
    } @else {
      {{ t('updateRequiredText') }}
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button type="button" [mat-dialog-close]="true">{{ t('updateNow') }}</button>
    @if (allowDelay) {
      <button mat-button type="button" [mat-dialog-close]="false">{{ t('delayFor5min') }}</button>
    }
  </mat-dialog-actions>
</ng-container>
